import { ComponentType, lazy, Suspense } from 'react'
import { GanttChartRowProps } from '@microservices/gantt-react-component'
import { LinearProgress } from '@mui/material'

const GanttChartRow = lazy<ComponentType<GanttChartRowProps>>(() =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  import('@microservices/gantt-react-component').then(({ GantChartRow }) => ({
    default: GantChartRow,
  }))
)

export default function GanttChartRowLazy({ ...props }: GanttChartRowProps) {
  return (
    <Suspense fallback={<LinearProgress />}>
      <GanttChartRow {...props} />
    </Suspense>
  )
}
